module.exports = __webpack_public_path__ + "img/6.a06a3c5c.png";